import { Component, DestroyRef, ElementRef, inject, input, signal, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent } from 'rxjs';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { ButtonComponent } from '@progress/kendo-angular-buttons';
import { PopupComponent } from '@progress/kendo-angular-popup';
import { AppMenuComponent } from '../app-menu/app-menu.component';

@Component({
  selector: 'rc-app-bar',
  standalone: true,
  templateUrl: './app-bar.component.html',
  styleUrl: './app-bar.component.scss',
  imports: [UserMenuComponent, ButtonComponent, PopupComponent, AppMenuComponent],
})
export class AppBarComponent {
  readonly backdrop = input(false);
  readonly menuAnchor = viewChild.required<ElementRef>('menuAnchor');
  readonly menuOpen = signal(false);

  constructor() {
    fromEvent<MouseEvent>(document, 'mousedown')
      .pipe(takeUntilDestroyed(inject(DestroyRef)))
      .subscribe((event) => {
        if (!this.menuOpen()) return;
        const anchor = this.menuAnchor().nativeElement as HTMLElement;
        if (anchor?.contains(event.target as Element)) return;
        // The route context menu (rcNavigate) is a body-appended popup outside the
        // flyout — a mousedown on it (Copy / Open-in-new-tab) must not close the flyout.
        if ((event.target as Element).closest?.('.app-bar-menu-popup, .rc-route-menu-popup')) return;
        this.menuOpen.set(false);
      });
  }

  toggleMenu() {
    this.menuOpen.update((open) => !open);
  }

  closeMenu() {
    this.menuOpen.set(false);
  }
}